import { datadogRum } from '@datadog/browser-rum';

export const logError = (error, context = {}) => {
  try {
    // Log error to Datadog RUM
    datadogRum.addError(error, {
      ...context,
      timestamp: new Date().toISOString(),
    });

    // Log to console in development
    if (process.env.NODE_ENV === 'development') {
      console.error('Error logged to Datadog:', error, context);
    }
  } catch (loggingError) {
    // Fallback error logging if Datadog fails
    console.error('Failed to log error to Datadog:', loggingError);
    console.error('Original error:', error);
    console.error('Context:', context);
  }
};

export const logApiError = (error, endpoint, requestData = {}) => {
  logError(error, {
    type: 'API_ERROR',
    endpoint,
    requestData,
    status: error?.response?.status,
    responseData: error?.response?.data,
  });
};

export const logRenderError = (error, componentName) => {
  logError(error, {
    type: 'RENDER_ERROR',
    componentName,
  });
};

export const logEventError = (error, eventName, eventData = {}) => {
  logError(error, {
    type: 'EVENT_ERROR',
    eventName,
    eventData,
  });
}; 